import styled from 'styled-components';

export const CardIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  max-height: 2rem;
  gap: 0.8rem;
`;
export const VerticalSeparator = styled.div`
  height: 1.6rem;
  width: 0.1rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;

export const CardImg = styled.img`
  width: 3.2rem;
  height: 2rem;
  resize-mode: contain;
`;
